import { Route, Routes } from 'react-router-dom';
import './App.css';
import Header from './Header';
import Home from './pages/Home';
import Projects from './pages/Projects';
import AboutMe from './pages/AboutMe';
import Contact from './pages/Contact';
import Footer from './Footer';

function App() {
  return (
    <>
    <Header/>
    <Routes>
      <Route path="/" element={<Home/>} />
      <Route path="/projects" element={<Projects/>} />
      <Route path="/aboutMe" element={<AboutMe/>} />
      <Route path="/contact" element={<Contact/>} />
    </Routes>
    
    <Footer/>
    </>
  );
}

export default App;
